import React from 'react';
import classnames from 'classnames';
import MinimalDumbo from '../MinimalDumbo';
import TextRenderer from '../../../TextRenderer';
import PollAnswerViewer from '../../../DaEditorWrapper/Viewer/PollAnswer';
import pollStyles from './Poll.scss';
const VotableAnswers = ({ poll })=>{
    return /*#__PURE__*/ React.createElement("ul", {
        className: pollStyles['answers']
    }, poll.answers.map(({ answerId, image, textContent })=>/*#__PURE__*/ React.createElement("li", {
            key: `answer:${answerId}`,
            className: pollStyles['answer']
        }, /*#__PURE__*/ React.createElement("div", {
            className: pollStyles['answer-row']
        }, image && /*#__PURE__*/ React.createElement(MinimalDumbo, {
            className: pollStyles['pollimage'],
            deviation: image,
            width: 72,
            height: 72
        }), /*#__PURE__*/ React.createElement(TextRenderer, {
            htmlExcerptLegacy: true,
            isPollWithHtmlExcerpt: true,
            className: classnames(pollStyles['answer-text'], 'da-editor-poll-thumb'),
            textContent: textContent,
            reactViewer: PollAnswerViewer,
            viewerKey: answerId
        })))));
};
export default VotableAnswers;
